export const successPageMessages = {
    default:{
        heading:"Success!",
        message:"Your Right to Work check has been successfully submitted. You will be contacted via email if additional information is required to complete your check."
    },
    "remote-imposter-check": {
        heading:"Document check failed!",
        message:"Your Right to Work check has been successfully submitted. However, as it has not been possible to validate your documents automatically, we would like to book a time for a video call to review them."
    },
    "in-person-document-verification": {
        heading:"Document check failed!",
        message:"Your Right to Work check has been successfully submitted. However, as it has not been possible to validate your documents automatically, we would like to review them in person."
    },
    "very-special": {
        heading:"Document check failed!",
        message:"Your Right to Work check has been successfully submitted. However, as it has not been possible to validate your documents automatically, we would like to meet in the office to review them."
    },
    "urgent-required-by-in-5-days": {
        heading:"Document check failed!",
        message:"Your Right to Work check has been successfully submitted. It has not been possible to validate your documents automatically. Your check is required to be completed in the next 5 days so please pick a time before then for an urgent appointment."
    },
}